module.exports = __webpack_public_path__ + "img/metal_f@2x.59864325.png";